
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">Terms of Service</h1>
          <p className="text-xl text-gray-600">
            Please read these terms carefully before using our services. By accessing our website and services, you agree to be bound by these terms.
          </p>
          <p className="text-sm text-gray-500 mt-4">Last updated: January 1, 2024</p>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        <div className="prose prose-lg max-w-none">
          
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Acceptance of Terms</h2>
            
            <p className="text-gray-600 mb-4">
              By accessing and using the OED Glamping Retreat Developments website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Booking and Reservations</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Booking Process</h3>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>All bookings are subject to availability and confirmation</li>
              <li>A valid credit card is required to secure your reservation</li>
              <li>Full payment may be required at the time of booking for certain rates</li>
              <li>Booking confirmations will be sent via email</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Cancellation Policy</h3>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Cancellations must be made at least 48 hours before check-in</li>
              <li>Cancellations within 48 hours are subject to a 50% charge</li>
              <li>No-shows will be charged the full amount</li>
              <li>Special events and peak season bookings may have different cancellation policies</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Check-in and Check-out</h3>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Check-in time: 3:00 PM</li>
              <li>Check-out time: 11:00 AM</li>
              <li>Early check-in and late check-out may be available for an additional fee</li>
              <li>Valid photo identification is required at check-in</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Guest Responsibilities</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Conduct</h3>
            <p className="text-gray-600 mb-4">Guests are expected to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Respect other guests and maintain reasonable noise levels</li>
              <li>Follow all property rules and regulations</li>
              <li>Treat accommodations and facilities with care</li>
              <li>Comply with local laws and regulations</li>
              <li>Report any damages or issues immediately</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Prohibited Activities</h3>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Smoking inside accommodations (designated outdoor areas only)</li>
              <li>Bringing pets without prior approval</li>
              <li>Exceeding maximum occupancy limits</li>
              <li>Hosting parties or events without permission</li>
              <li>Damaging property or natural environment</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Payment Terms</h2>
            
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>All rates are quoted in US Dollars and include applicable taxes unless otherwise stated</li>
              <li>Payment is due at the time of booking or as specified in your reservation</li>
              <li>We accept major credit cards and electronic payments</li>
              <li>Additional charges may apply for extra services, damages, or incidentals</li>
              <li>Rates are subject to change without notice</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Liability and Insurance</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Limitation of Liability</h3>
            <p className="text-gray-600 mb-4">
              OED Glamping Retreat Developments shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use of our services or accommodations, except as required by law.
            </p>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Guest Insurance</h3>
            <p className="text-gray-600 mb-4">
              We strongly recommend that guests obtain travel insurance to cover trip cancellations, medical emergencies, and personal belongings. OED Glamping is not responsible for lost, stolen, or damaged personal items.
            </p>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Force Majeure</h3>
            <p className="text-gray-600 mb-4">
              We are not liable for any failure to perform our obligations due to circumstances beyond our reasonable control, including but not limited to natural disasters, government actions, or other force majeure events.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Privacy and Data Protection</h2>
            
            <p className="text-gray-600 mb-4">
              Your privacy is important to us. Please review our Privacy Policy, which also governs your use of our services, to understand our practices regarding the collection and use of your personal information.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Intellectual Property</h2>
            
            <p className="text-gray-600 mb-4">
              All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of OED Glamping Retreat Developments and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Website Use</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Acceptable Use</h3>
            <p className="text-gray-600 mb-4">You agree not to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Use the website for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the website's operation or security</li>
              <li>Submit false or misleading information</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Dispute Resolution</h2>
            
            <p className="text-gray-600 mb-4">
              Any disputes arising from these terms or your use of our services will be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. The arbitration will take place in Alabama, and Alabama law will govern these terms.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Modifications</h2>
            
            <p className="text-gray-600 mb-4">
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting on our website. Your continued use of our services after any changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Severability</h2>
            
            <p className="text-gray-600 mb-4">
              If any provision of these terms is found to be unenforceable or invalid, the remaining provisions will continue to be valid and enforceable to the fullest extent permitted by law.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Information</h2>
            
            <p className="text-gray-600 mb-4">
              If you have any questions about these Terms of Service, please contact us:
            </p>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <i className="ri-mail-line text-emerald-600"></i>
                  <span className="text-gray-700">Create@oedtinyhomebuilders.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-phone-line text-emerald-600"></i>
                  <span className="text-gray-700">(256) 268-7146</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-map-pin-line text-emerald-600"></i>
                  <span className="text-gray-700">1591 Allison Mill Rd, Talladega, AL 35160</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}